import { Modal } from "@risalabs_frontend_org/oasis-ui-kit";
import { ModalId } from "../../../enums/modalId";
import WarningIcon from "../../../svg/warningIcon";
import { CANCEL_BUTTON_TEXT } from "../../authorisationDetails/utils/constants";
import {
  INCORRECT_LETTER_CONFIRM_LABEL,
  INCORRECT_LETTER_TITLE,
  MARKING_LABEL,
} from "../utils/constants";

interface IncorrectLetterModalProps {
  /** The J-code the letter is being taken off (shown in the prompt). */
  jCode?: string | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirms "Incorrect Letter": the letter leaves this J-code and, if it belongs nowhere else, is unmatched. */
const IncorrectLetterModal = ({
  jCode,
  isSubmitting,
  onConfirm,
  onClose,
}: IncorrectLetterModalProps) => (
  <Modal
    dialogId={ModalId.FAX_LETTER_INCORRECT_MODAL}
    title={INCORRECT_LETTER_TITLE}
    saveButtonText={
      isSubmitting ? MARKING_LABEL : INCORRECT_LETTER_CONFIRM_LABEL
    }
    cancelText={CANCEL_BUTTON_TEXT}
    onSave={onConfirm}
    onCancel={onClose}
    onClose={onClose}
    disableSave={isSubmitting}
    disableCancel={isSubmitting}
  >
    <div className="flex flex-col items-center justify-center gap-4 py-4 text-center">
      <WarningIcon />
      <div className="text-sm text-primaryGray-1">
        This letter will be removed from {jCode || "this J-code"} and moved to
        the unmatched letters. Are you sure it does not belong here?
      </div>
    </div>
  </Modal>
);

export default IncorrectLetterModal;
